import { useQuery } from '@tanstack/react-query';
import { useLocation } from '../context/LocationContext';
import { useMemo } from 'react';
import { usePlacements } from '../context/PlacementsStore';

export const useIosPlacementId = () => {
  return useQuery<number | null>({
    queryKey: ['iosPlacementId'],
    queryFn: () => {
      const id = localStorage.getItem('ios_placement_id');
      return id ? Number(id) : null;
    },
    staleTime: Infinity,
    retry: false,
  });
};

export const useDefaultPlacement = () => {
  const { data: iosPlacementId } = useIosPlacementId();
  const placements = usePlacements();

  return useMemo(() => {
    if (iosPlacementId) {
      return { defaultPlacement: iosPlacementId };
    }

    if (placements[0] && placements.length === 1) {
      return { defaultPlacement: placements[0].id };
    }

    return { defaultPlacement: undefined };
  }, [iosPlacementId, placements]);
};

export const useAutomaticPrintingPlacement = () => {
  const { defaultPlacement } = useDefaultPlacement();
  const { location } = useLocation();

  /**
   * UK have been using cash for a while already and we do not want to automatically print cash receipts in UK just because its a legal requirement in Norway
   */
  if (location?.countryCode === 'UK') {
    return { defaultPlacement: undefined };
  }

  return { defaultPlacement };
};
